/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


import ArgosFlexbox from '../../../../../../components/Containers/ArgosFlexbox';
import LinearProgressWithLabel, {normalize} from '../../../../../../components/LinearProgress';
import React from 'react';
import {selectMergeSetsLocalState} from '../../../../../../../redux/ducks/CoverageRequirements/slice';
import Typography from '@mui/material/Typography';
import {useAppSelector} from '../../../../../../../redux/hooks';


interface MergeStatusProps {
  mergeSetId: string
  generationStatus: any
}


/**
 * Renders the merge status component, showing the current status, percentage, 
 * and/or message when applicable.
 *
 * @component
 * @param {MergeStatusProps} props - The props for the MergeStatus component.
 * @returns {JSX.Element} The rendered MergeStatus component.
 */
const MergeStatus = (props: MergeStatusProps): JSX.Element => {
  const selectedMergeSetExecutionStatus = useAppSelector(selectMergeSetsLocalState)
  const currentDatasetState = selectedMergeSetExecutionStatus?.[props.mergeSetId ?? ''] ?? props.generationStatus

  return (
    <ArgosFlexbox vertical style={{justifyContent: "center", padding: 10, paddingTop: 0, width: "100%"}}>
      {currentDatasetState.status !== "In Progress" && <Typography>{currentDatasetState.status}</Typography>}
      {currentDatasetState.status === "In Progress" && <ArgosFlexbox>
        <LinearProgressWithLabel
          style={{width: "30ch"}}
          variant={'determinate'}
          percentage={normalize(currentDatasetState.percentage)}
          currentIteration={currentDatasetState.currentIteration}
          totalIterations={currentDatasetState.totalIterations}
        />
        <Typography>{currentDatasetState.message}</Typography>
      </ArgosFlexbox>}
    </ArgosFlexbox>
  )
}


export default MergeStatus
